import { c as _c } from "react/compiler-runtime";
import { PROJECT_BACKGROUND_TASKS_REQUIRED_COLUMNS } from "@pages/project-details/project-bg-tasks/project-background-tasks-columns";
import { ProjectBackgroundTasksTable } from "@pages/project-details/project-bg-tasks/project-background-tasks-table";

/**
 * Contains the skeleton to show when loading the backgrounds tasks in the project activity tab.
 */
export function ProjectBackgroundTasksSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ProjectBackgroundTasksTable sdbBackgroundsTasks={[]} isLoading={true} requiredColumns={PROJECT_BACKGROUND_TASKS_REQUIRED_COLUMNS} projectId="" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}